import { getLocalizedValue } from '@/lib/utils'
import type { Locale, LocalizedCopy } from '@/types/site'

export const dashboardCopy: {
  title: LocalizedCopy<string>
  backToSite: LocalizedCopy<string>
  navDashboard: LocalizedCopy<string>
  headerTitle: LocalizedCopy<string>
  statProjects: LocalizedCopy<string>
  statClients: LocalizedCopy<string>
  statInquiries: LocalizedCopy<string>
  statTeam: LocalizedCopy<string>
  statContentBlocks: LocalizedCopy<string>
  statSeoPages: LocalizedCopy<string>
  statVisitsWeek: LocalizedCopy<string>
  statVisitsAll: LocalizedCopy<string>
  welcome: LocalizedCopy<string>
  sectionOverview: LocalizedCopy<string>
  sectionContent: LocalizedCopy<string>
  sectionSeo: LocalizedCopy<string>
  sectionAnalytics: LocalizedCopy<string>
  sectionSite: LocalizedCopy<string>
  sectionSettings: LocalizedCopy<string>
  navContentHome: LocalizedCopy<string>
  navSeo: LocalizedCopy<string>
  navAnalytics: LocalizedCopy<string>
  navNavigation: LocalizedCopy<string>
  navFooter: LocalizedCopy<string>
  navMedia: LocalizedCopy<string>
  navSettings: LocalizedCopy<string>
  navSettingsGoogle: LocalizedCopy<string>
  navSettingsTracking: LocalizedCopy<string>
  navArticles: LocalizedCopy<string>
  navProjects: LocalizedCopy<string>
  navProjectCategories: LocalizedCopy<string>
  navServices: LocalizedCopy<string>
  navResources: LocalizedCopy<string>
  navClientLogos: LocalizedCopy<string>
  navProfile: LocalizedCopy<string>
  navUsers: LocalizedCopy<string>
  profileTitle: LocalizedCopy<string>
  profileSubtitle: LocalizedCopy<string>
  profileName: LocalizedCopy<string>
  profileEmail: LocalizedCopy<string>
  profileAvatar: LocalizedCopy<string>
  loginTitle: LocalizedCopy<string>
  loginSubtitle: LocalizedCopy<string>
  loginEmail: LocalizedCopy<string>
  loginPassword: LocalizedCopy<string>
  loginSubmit: LocalizedCopy<string>
  loginError: LocalizedCopy<string>
  loginGoogle: LocalizedCopy<string>
  loginGoogleUnavailable: LocalizedCopy<string>
  loginForgotPassword: LocalizedCopy<string>
  forgotPasswordTitle: LocalizedCopy<string>
  forgotPasswordSubtitle: LocalizedCopy<string>
  forgotPasswordSubmit: LocalizedCopy<string>
  forgotPasswordSent: LocalizedCopy<string>
  forgotPasswordBack: LocalizedCopy<string>
  resetPasswordTitle: LocalizedCopy<string>
  resetPasswordSubtitle: LocalizedCopy<string>
  resetPasswordNew: LocalizedCopy<string>
  resetPasswordConfirm: LocalizedCopy<string>
  resetPasswordSubmit: LocalizedCopy<string>
  resetPasswordSuccess: LocalizedCopy<string>
  loginPending: LocalizedCopy<string>
  loginRejected: LocalizedCopy<string>
  usersTitle: LocalizedCopy<string>
  usersSubtitle: LocalizedCopy<string>
  userColName: LocalizedCopy<string>
  userColEmail: LocalizedCopy<string>
  userColStatus: LocalizedCopy<string>
  userColActions: LocalizedCopy<string>
  statusPending: LocalizedCopy<string>
  statusApproved: LocalizedCopy<string>
  statusRejected: LocalizedCopy<string>
  actionApprove: LocalizedCopy<string>
  actionReject: LocalizedCopy<string>
  loadingDashboard: LocalizedCopy<string>
  userMenu: LocalizedCopy<string>
  profileNav: LocalizedCopy<string>
  signOut: LocalizedCopy<string>
  notifications: LocalizedCopy<string>
  notificationsEmpty: LocalizedCopy<string>
  save: LocalizedCopy<string>
  saving: LocalizedCopy<string>
  loadError: LocalizedCopy<string>
  saved: LocalizedCopy<string>
  mediaUploadButton: LocalizedCopy<string>
  mediaUploadHint: LocalizedCopy<string>
  mediaLibraryHeading: LocalizedCopy<string>
  mediaCopyUrl: LocalizedCopy<string>
  mediaCopied: LocalizedCopy<string>
  mediaEmpty: LocalizedCopy<string>
  mediaUploading: LocalizedCopy<string>
  mediaAlreadyInLibrary: LocalizedCopy<string>
  mediaPickerTitle: LocalizedCopy<string>
  mediaPickerSearchPlaceholder: LocalizedCopy<string>
  mediaPickerHint: LocalizedCopy<string>
  mediaPickerClose: LocalizedCopy<string>
  mediaPickerFeaturedButton: LocalizedCopy<string>
  mediaFolderRoot: LocalizedCopy<string>
  mediaNewFolder: LocalizedCopy<string>
  mediaCreateFolder: LocalizedCopy<string>
  mediaFolderNamePlaceholder: LocalizedCopy<string>
  mediaFolderCreated: LocalizedCopy<string>
  mediaFoldersSection: LocalizedCopy<string>
  mediaRenameFolder: LocalizedCopy<string>
  mediaRenameFolderTitle: LocalizedCopy<string>
  mediaDeleteFolder: LocalizedCopy<string>
  mediaDeleteFolderTitle: LocalizedCopy<string>
  mediaDeleteFolderDescription: LocalizedCopy<string>
  mediaFolderRenamed: LocalizedCopy<string>
  mediaFolderDeleted: LocalizedCopy<string>
  mediaDeleteFile: LocalizedCopy<string>
  mediaDeleteDescription: LocalizedCopy<string>
  dialogConfirm: LocalizedCopy<string>
  dialogCancel: LocalizedCopy<string>
  dialogDeleteTitle: LocalizedCopy<string>
  richTextLinkDialogTitle: LocalizedCopy<string>
  richTextLinkUrlLabel: LocalizedCopy<string>
  richTextImageDialogTitle: LocalizedCopy<string>
  richTextImageUrlLabel: LocalizedCopy<string>
  richTextLinkClearHint: LocalizedCopy<string>
  pageTitles: Record<string, LocalizedCopy<string>>
  pageDescriptions: Record<string, LocalizedCopy<string>>
} = {
  title: { en: 'Dashboard', ar: 'لوحة التحكم' },
  backToSite: { en: 'Back to website', ar: 'العودة للموقع' },
  navDashboard: { en: 'Overview', ar: 'نظرة عامة' },
  headerTitle: { en: 'Pro Damac — Dashboard', ar: 'برو دماك — لوحة التحكم' },
  statProjects: { en: 'Projects', ar: 'مشاريع' },
  statClients: { en: 'Clients', ar: 'عملاء' },
  statInquiries: { en: 'Inquiries', ar: 'استفسارات' },
  statTeam: { en: 'Team', ar: 'فريق' },
  statContentBlocks: { en: 'Content blocks', ar: 'كتل المحتوى' },
  statSeoPages: { en: 'SEO pages', ar: 'صفحات SEO' },
  statVisitsWeek: { en: 'Visits (7 days)', ar: 'زيارات (7 أيام)' },
  statVisitsAll: { en: 'Visits (total)', ar: 'زيارات (الإجمالي)' },
  welcome: {
    en: 'Welcome to the dashboard. Metrics below sync from your Laravel API.',
    ar: 'مرحباً بك. المؤشرات أدناه تُحدَّث من واجهة Laravel.',
  },
  sectionOverview: { en: 'OVERVIEW', ar: 'نظرة عامة' },
  sectionContent: { en: 'CONTENT', ar: 'المحتوى' },
  sectionSeo: { en: 'SEO & ANALYTICS', ar: 'SEO والتحليلات' },
  sectionAnalytics: { en: 'ANALYTICS', ar: 'التحليلات' },
  sectionSite: { en: 'SITE', ar: 'الموقع' },
  sectionSettings: { en: 'SETTINGS', ar: 'الإعدادات' },
  navContentHome: { en: 'Home sections', ar: 'أقسام الصفحة الرئيسية' },
  navSeo: { en: 'SEO & meta', ar: 'الوصف والوسوم' },
  navAnalytics: { en: 'Visits', ar: 'الزيارات' },
  navNavigation: { en: 'Navigation', ar: 'القائمة' },
  navFooter: { en: 'Footer', ar: 'التذييل' },
  navMedia: { en: 'Media', ar: 'الوسائط' },
  navSettings: { en: 'General settings', ar: 'الإعدادات العامة' },
  navSettingsGoogle: { en: 'Google sign-in', ar: 'تسجيل Google' },
  navSettingsTracking: { en: 'Analytics & pixels', ar: 'التحليلات والبكسل' },
  navArticles: { en: 'Articles', ar: 'المقالات' },
  navProjects: { en: 'Projects', ar: 'المشاريع' },
  navProjectCategories: { en: 'Project categories', ar: 'أقسام المشاريع' },
  navServices: { en: 'Services', ar: 'الخدمات' },
  navResources: { en: 'Resources', ar: 'الموارد' },
  navClientLogos: { en: 'Partner logos', ar: 'شعارات الشركاء' },
  navProfile: { en: 'Profile', ar: 'الملف الشخصي' },
  navUsers: { en: 'Users', ar: 'المستخدمون' },
  profileTitle: { en: 'Profile', ar: 'الملف الشخصي' },
  profileSubtitle: { en: 'Update how your name appears in the dashboard.', ar: 'حدّث اسم العرض في لوحة التحكم.' },
  profileName: { en: 'Display name', ar: 'اسم العرض' },
  profileEmail: { en: 'Email', ar: 'البريد الإلكتروني' },
  profileAvatar: { en: 'Photo', ar: 'الصورة' },
  loginTitle: { en: 'Sign in', ar: 'تسجيل الدخول' },
  loginSubtitle: { en: 'Use your admin account from the Laravel API.', ar: 'استخدم حساب المسؤول من خادم Laravel.' },
  loginEmail: { en: 'Email', ar: 'البريد الإلكتروني' },
  loginPassword: { en: 'Password', ar: 'كلمة المرور' },
  loginSubmit: { en: 'Continue', ar: 'متابعة' },
  loginError: { en: 'Could not sign in. Check your credentials.', ar: 'تعذّر تسجيل الدخول. تحقق من البيانات.' },
  loginGoogle: { en: 'Continue with Google', ar: 'المتابعة مع Google' },
  loginGoogleUnavailable: {
    en: 'Google sign-in is not configured. Set VITE_GOOGLE_CLIENT_ID in the frontend .env (same Web client ID as the API).',
    ar: 'تسجيل الدخول بـ Google غير مفعّل. اضبط VITE_GOOGLE_CLIENT_ID في ملف .env للواجهة (نفس معرّف عميل الويب في الـ API).',
  },
  loginForgotPassword: { en: 'Forgot password?', ar: 'نسيت كلمة المرور؟' },
  forgotPasswordTitle: { en: 'Reset password', ar: 'استعادة كلمة المرور' },
  forgotPasswordSubtitle: {
    en: 'Enter your email and we will send you a reset link if an account exists.',
    ar: 'أدخل بريدك الإلكتروني وسنرسل رابط الاستعادة إن وُجد حساب.',
  },
  forgotPasswordSubmit: { en: 'Send reset link', ar: 'إرسال رابط الاستعادة' },
  forgotPasswordSent: {
    en: 'If an account exists for that email, you will receive a reset link shortly.',
    ar: 'إن وُجد حساب لهذا البريد، ستصلك رسالة تحتوي على الرابط قريباً.',
  },
  forgotPasswordBack: { en: 'Back to sign in', ar: 'العودة لتسجيل الدخول' },
  resetPasswordTitle: { en: 'Choose a new password', ar: 'اختر كلمة مرور جديدة' },
  resetPasswordSubtitle: {
    en: 'Enter and confirm your new password below.',
    ar: 'أدخل كلمة المرور الجديدة وأكدها أدناه.',
  },
  resetPasswordNew: { en: 'New password', ar: 'كلمة المرور الجديدة' },
  resetPasswordConfirm: { en: 'Confirm password', ar: 'تأكيد كلمة المرور' },
  resetPasswordSubmit: { en: 'Update password', ar: 'تحديث كلمة المرور' },
  resetPasswordSuccess: {
    en: 'Your password was updated. You can sign in now.',
    ar: 'تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.',
  },
  loginPending: {
    en: 'Your account is pending approval by an administrator.',
    ar: 'حسابك بانتظار موافقة المسؤول.',
  },
  loginRejected: {
    en: 'Your account was not approved.',
    ar: 'لم تُوافَق على حسابك.',
  },
  usersTitle: { en: 'Users', ar: 'المستخدمون' },
  usersSubtitle: { en: 'Approve or reject Google sign-in requests.', ar: 'الموافقة على طلبات تسجيل الدخول عبر Google.' },
  userColName: { en: 'Name', ar: 'الاسم' },
  userColEmail: { en: 'Email', ar: 'البريد' },
  userColStatus: { en: 'Status', ar: 'الحالة' },
  userColActions: { en: 'Actions', ar: 'إجراءات' },
  statusPending: { en: 'Pending', ar: 'قيد الانتظار' },
  statusApproved: { en: 'Approved', ar: 'موافق' },
  statusRejected: { en: 'Rejected', ar: 'مرفوض' },
  actionApprove: { en: 'Approve', ar: 'موافقة' },
  actionReject: { en: 'Reject', ar: 'رفض' },
  loadingDashboard: { en: 'Loading…', ar: 'جارٍ التحميل…' },
  userMenu: { en: 'Account', ar: 'الحساب' },
  profileNav: { en: 'My profile', ar: 'ملفي الشخصي' },
  signOut: { en: 'Sign out', ar: 'خروج' },
  notifications: { en: 'Notifications', ar: 'الإشعارات' },
  notificationsEmpty: { en: 'No notifications yet.', ar: 'لا توجد إشعارات بعد.' },
  save: { en: 'Save', ar: 'حفظ' },
  saving: { en: 'Saving…', ar: 'جارٍ الحفظ…' },
  loadError: { en: 'Failed to load data.', ar: 'تعذّر تحميل البيانات.' },
  saved: { en: 'Saved.', ar: 'تم الحفظ.' },
  mediaUploadButton: { en: 'Upload file', ar: 'رفع ملف' },
  mediaUploadHint: {
    en: 'JPEG, PNG, GIF, WebP, or SVG — max 10 MB per file. You can select multiple files at once.',
    ar: 'JPEG أو PNG أو GIF أو WebP أو SVG — بحد أقصى 10 ميجابايت لكل ملف. يمكن اختيار عدة ملفات دفعة واحدة.',
  },
  mediaLibraryHeading: { en: 'Library', ar: 'المكتبة' },
  mediaCopyUrl: { en: 'Copy URL', ar: 'نسخ الرابط' },
  mediaCopied: { en: 'Link copied.', ar: 'تم نسخ الرابط.' },
  mediaEmpty: {
    en: 'No media yet. Upload a file above to add it to the library.',
    ar: 'لا توجد وسائط بعد. ارفع ملفاً أعلاه لإضافته إلى المكتبة.',
  },
  mediaUploading: { en: 'Uploading…', ar: 'جارٍ الرفع…' },
  mediaAlreadyInLibrary: {
    en: 'This file is already in the library.',
    ar: 'هذا الملف موجود مسبقاً في المكتبة.',
  },
  mediaPickerTitle: { en: 'Choose from media library', ar: 'اختر من مكتبة الوسائط' },
  mediaPickerSearchPlaceholder: { en: 'Search…', ar: 'بحث…' },
  mediaPickerHint: {
    en: 'Upload a file to add it to the library, then click an image to use it.',
    ar: 'ارفع ملفاً لإضافته للمكتبة، ثم انقر صورة لاستخدامها.',
  },
  mediaPickerClose: { en: 'Close', ar: 'إغلاق' },
  mediaPickerFeaturedButton: { en: 'Choose image', ar: 'اختيار صورة' },
  mediaFolderRoot: { en: 'All files', ar: 'كل الملفات' },
  mediaNewFolder: { en: 'New folder', ar: 'مجلد جديد' },
  mediaCreateFolder: { en: 'Create folder', ar: 'إنشاء مجلد' },
  mediaFolderNamePlaceholder: { en: 'Folder name', ar: 'اسم المجلد' },
  mediaFolderCreated: { en: 'Folder created.', ar: 'تم إنشاء المجلد.' },
  mediaFoldersSection: { en: 'Folders', ar: 'المجلدات' },
  mediaRenameFolder: { en: 'Rename folder', ar: 'إعادة تسمية المجلد' },
  mediaRenameFolderTitle: { en: 'Rename folder', ar: 'إعادة تسمية المجلد' },
  mediaDeleteFolder: { en: 'Delete folder', ar: 'حذف المجلد' },
  mediaDeleteFolderTitle: { en: 'Delete folder?', ar: 'تأكيد حذف المجلد؟' },
  mediaDeleteFolderDescription: {
    en: 'This removes the folder. Files inside will be moved to the root (not deleted).',
    ar: 'سيتم حذف المجلد. الملفات بداخله ستنتقل إلى المجلد الرئيسي (لن تُحذف).',
  },
  mediaFolderRenamed: { en: 'Folder renamed.', ar: 'تم إعادة تسمية المجلد.' },
  mediaFolderDeleted: { en: 'Folder deleted.', ar: 'تم حذف المجلد.' },
  mediaDeleteFile: { en: 'Delete file', ar: 'حذف الملف' },
  mediaDeleteDescription: {
    en: 'This removes the file from the library and deletes it from the server.',
    ar: 'سيتم إزالة الملف من المكتبة وحذفه من الخادم.',
  },
  dialogConfirm: { en: 'Confirm', ar: 'تأكيد' },
  dialogCancel: { en: 'Cancel', ar: 'إلغاء' },
  dialogDeleteTitle: { en: 'Delete?', ar: 'تأكيد الحذف؟' },
  richTextLinkDialogTitle: { en: 'Link URL', ar: 'رابط الارتباط' },
  richTextLinkUrlLabel: { en: 'URL', ar: 'الرابط' },
  richTextImageDialogTitle: { en: 'Image URL', ar: 'رابط الصورة' },
  richTextImageUrlLabel: { en: 'Image URL', ar: 'عنوان الصورة' },
  richTextLinkClearHint: {
    en: 'Clear the field and confirm to remove the link.',
    ar: 'امسح الحقل ثم أكّد لإزالة الرابط.',
  },
  pageTitles: {
    overview: { en: 'Overview', ar: 'نظرة عامة' },
    'content/home': { en: 'Home content', ar: 'محتوى الصفحة الرئيسية' },
    seo: { en: 'SEO', ar: 'SEO' },
    analytics: { en: 'Analytics', ar: 'التحليلات' },
    navigation: { en: 'Navigation', ar: 'القائمة' },
    footer: { en: 'Footer', ar: 'التذييل' },
    media: { en: 'Media library', ar: 'مكتبة الوسائط' },
    settings: { en: 'General settings', ar: 'الإعدادات العامة' },
    settingsGoogle: { en: 'Google OAuth', ar: 'إعدادات Google' },
    settingsTracking: { en: 'Analytics & ad pixels', ar: 'التحليلات وبكسل الإعلانات' },
    profile: { en: 'Profile', ar: 'الملف الشخصي' },
    users: { en: 'Users', ar: 'المستخدمون' },
    articles: { en: 'Articles', ar: 'المقالات' },
    projects: { en: 'Projects (CMS)', ar: 'المشاريع (CMS)' },
    'project-categories': { en: 'Project categories', ar: 'أقسام المشاريع' },
    services: { en: 'Services (CMS)', ar: 'الخدمات (CMS)' },
    resources: { en: 'Resources (CMS)', ar: 'الموارد (CMS)' },
    'client-logos': { en: 'Client logos', ar: 'شعارات العملاء' },
  },
  pageDescriptions: {
    overview: {
      en: 'Key metrics from your Laravel API: content blocks, SEO pages, and visit traffic.',
      ar: 'مؤشرات رئيسية من واجهة Laravel: كتل المحتوى، صفحات SEO، وحركة الزيارات.',
    },
    'content/home': {
      en: 'Edit home page content blocks (HTML) and optional meta JSON.',
      ar: 'تحرير أقسام الصفحة الرئيسية (HTML) وحقول meta الاختيارية بصيغة JSON.',
    },
    seo: {
      en: 'Manage titles, descriptions, Open Graph, and indexing per URL path.',
      ar: 'إدارة العناوين والأوصاف ووسوم المشاركة وفهرسة كل مسار.',
    },
    analytics: {
      en: 'Recent visits with timestamps, paths, IPs, and user agents.',
      ar: 'سجل الزيارات الأخيرة مع الوقت والمسار وعنوان IP ووكيل المستخدم.',
    },
    navigation: {
      en: 'JSON array of navigation items (labels and links). Invalid JSON cannot be saved.',
      ar: 'مصفوفة JSON لعناصر القائمة (النصوص والروابط). JSON غير صالح لن يُحفَظ.',
    },
    footer: {
      en: 'Footer structure as JSON — links and copy for the public site.',
      ar: 'هيكل التذييل بصيغة JSON — الروابط والنصوص للموقع العام.',
    },
    media: {
      en: 'Upload images and copy URLs from your media library (stored in site config).',
      ar: 'ارفع الصور وانسخ الروابط من مكتبة الوسائط (مخزّنة في إعدادات الموقع).',
    },
    settings: {
      en: 'Contact, social links, and site-wide options merged into site config; other keys are preserved.',
      ar: 'التواصل والروابط الاجتماعية وخيارات الموقع العامة تُدمج في إعدادات الموقع مع الإبقاء على أي مفاتيح أخرى.',
    },
    settingsGoogle: {
      en: 'Copy the site origin and API endpoint into Google Cloud Console for Sign in with Google.',
      ar: 'انسخ أصل الموقع ونقطة نهاية الـ API إلى Google Cloud Console لتسجيل الدخول بـ Google.',
    },
    settingsTracking: {
      en: 'GA4, Google Ads, Meta, TikTok, and Snapchat IDs for the public site (stored in site config).',
      ar: 'معرّفات GA4 وإعلانات Google وميتا وتيك توك وسناب للموقع العام (مخزّنة في إعدادات الموقع).',
    },
    profile: {
      en: 'Update how your name appears in the dashboard.',
      ar: 'حدّث اسم العرض كما يظهر في لوحة التحكم.',
    },
    users: {
      en: 'Approve or reject Google sign-in requests.',
      ar: 'الموافقة على طلبات تسجيل الدخول عبر Google أو رفضها.',
    },
    articles: {
      en: 'Manage blog articles: create, edit, delete. HTML is sanitized on save.',
      ar: 'إدارة مقالات المدونة: إنشاء، تعديل، وحذف. يُنقّى HTML عند الحفظ.',
    },
    projects: {
      en: 'Projects shown on the public marketing site.',
      ar: 'المشاريع المعروضة في الموقع التسويقي العام.',
    },
    'project-categories': {
      en: 'Organize projects into categories. Drag to reorder, edit names, or delete.',
      ar: 'نظّم المشاريع في أقسام. اسحب لإعادة الترتيب، أو عدّل الأسماء، أو احذف.',
    },
    services: {
      en: 'Service pages for the public site — same structured fields as projects.',
      ar: 'صفحات الخدمات للموقع العام — نفس الحقول المنظمة كالمشاريع.',
    },
    resources: {
      en: 'Resource pages for downloads, guides, or reference content.',
      ar: 'صفحات الموارد للتحميلات أو الأدلة أو المحتوى المرجعي.',
    },
    serviceNew: {
      en: 'Create a service entry with rich HTML and media metadata.',
      ar: 'إنشاء خدمة مع HTML غني وبيانات وصفية للوسائط.',
    },
    serviceEdit: {
      en: 'Update service content, slug, and publishing options.',
      ar: 'تحديث محتوى الخدمة والـ slug وخيارات النشر.',
    },
    serviceView: {
      en: 'Admin preview of this service before it goes live.',
      ar: 'معاينة إدارية للخدمة قبل النشر.',
    },
    resourceNew: {
      en: 'Create a resource page with the same editor as projects.',
      ar: 'إنشاء صفحة مورد باستخدام نفس محرر المشاريع.',
    },
    resourceEdit: {
      en: 'Update resource fields, media, and publishing.',
      ar: 'تحديث حقول المورد والوسائط والنشر.',
    },
    resourceView: {
      en: 'Admin preview of this resource page.',
      ar: 'معاينة إدارية لصفحة المورد.',
    },
    'client-logos': {
      en: 'Partner logos on the home page (path or full URL).',
      ar: 'شعارات الشركاء في الصفحة الرئيسية (مسار نسبي أو رابط كامل).',
    },
    articleNew: {
      en: 'Create a new post. Rich text is sanitized when saved.',
      ar: 'إنشاء مقال جديد. يُنقّى النص الغني عند الحفظ.',
    },
    articleEdit: {
      en: 'Update slug, excerpts, body, and publishing options.',
      ar: 'تحديث الـ slug والمقتطفات والمحتوى وخيارات النشر.',
    },
    projectNew: {
      en: 'Structured steps: basics, category, cover & gallery, rich story — same quality bar as the public projects page.',
      ar: 'خطوات منظمة: الأساسيات، التصنيف، الغلاف والمعرض، القصة الغنية — بجودة احترافية كصفحة المشاريع العامة.',
    },
    projectEdit: {
      en: 'Update all project fields, media gallery, and publishing.',
      ar: 'تحديث حقول المشروع ومعرض الصور والنشر.',
    },
    projectView: {
      en: 'Admin preview of how this project reads in the dashboard.',
      ar: 'معاينة إدارية لمحتوى المشروع كما يظهر بعد النشر.',
    },
  },
}

export function resolveDashboardPageKey(pathname: string): string {
  const match = pathname.match(/\/[^/]+\/dashboard(?:\/(.*))?$/)
  const rest = (match?.[1] ?? '').replace(/\/$/, '')
  if (rest === '') {
    return 'overview'
  }
  if (rest === 'profile' || rest.startsWith('profile/')) {
    return 'profile'
  }
  if (rest === 'users' || rest.startsWith('users/')) {
    return 'users'
  }
  if (rest === 'articles' || rest.startsWith('articles/')) {
    return 'articles'
  }
  if (rest === 'project-categories' || rest.startsWith('project-categories/')) {
    return 'project-categories'
  }
  if (rest === 'projects' || rest.startsWith('projects/')) {
    return 'projects'
  }
  if (rest === 'services' || rest.startsWith('services/')) {
    return 'services'
  }
  if (rest === 'resources' || rest.startsWith('resources/')) {
    return 'resources'
  }
  if (rest === 'client-logos' || rest.startsWith('client-logos/')) {
    return 'client-logos'
  }
  if (rest === 'settings/google') {
    return 'settingsGoogle'
  }
  if (rest === 'settings/tracking') {
    return 'settingsTracking'
  }
  if (rest === 'settings' || rest.startsWith('settings/')) {
    return 'settings'
  }
  return rest
}

export function getDashboardPageDescription(locale: Locale, key: string): string {
  const copy = dashboardCopy.pageDescriptions[key]
  if (!copy) {
    return ''
  }
  return getLocalizedValue(copy, locale)
}
